import { createContext, FC } from 'react';

type ServerVarsContextType = {
    isDesktop?: boolean | null;
    isMobile?: boolean | null;
    isSbAdsEnabled?: boolean | null;
    isTablet?: boolean | null;
    clientConf?: ObjectType | null;
    localeOrigin?: string | null;
    isSearchQueryApplied?: boolean | null;
    isSmallerSbCategoryTilesVariant?: boolean | null;
    isSbTopNavVariant?: boolean | null;
    isPdpMetaDescRemovalVariant?: boolean | null;
};

export const ServerVarsContext = createContext<ServerVarsContextType>({
    isDesktop: null,
    isMobile: null,
    isSbAdsEnabled: null,
    isTablet: null,
    clientConf: {},
    localeOrigin: null,
    isSearchQueryApplied: null,
    isSmallerSbCategoryTilesVariant: null,
    isSbTopNavVariant: null,
    isPdpMetaDescRemovalVariant: null,
});

export const ServerVarsContextConsumer = ServerVarsContext.Consumer;

export const ServerVarsContextProvider: FC<ServerVarsContextType> = ({
    children,
    isDesktop,
    isMobile,
    isSbAdsEnabled,
    isTablet,
    clientConf,
    localeOrigin,
    isSearchQueryApplied,
    isSmallerSbCategoryTilesVariant,
    isSbTopNavVariant,
    isPdpMetaDescRemovalVariant,
}) => {
    return (
        <ServerVarsContext.Provider
            value={{
                isDesktop,
                isMobile,
                isSbAdsEnabled,
                isTablet,
                clientConf,
                localeOrigin,
                isSearchQueryApplied,
                isSmallerSbCategoryTilesVariant,
                isSbTopNavVariant,
                isPdpMetaDescRemovalVariant,
            }}
        >
            {children}
        </ServerVarsContext.Provider>
    );
};
